enum ObjectType {
  Portfolio = 'portfolio',
  Project = 'project',
  Board = 'board',
  Sprint = 'sprint',
  Initiative = 'initiative',
}

type ObjectKeyInfo = {
  key: string;
  objectType: ObjectType;
  usedInComponents: string[];
};

export { ObjectType };
export type { ObjectKeyInfo };
